// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import uploader from "vue-simple-uploader";
// import router from './router'
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import echarts from "echarts";
import myAxios from "@/assets/js/myaxios.js";
import "@/assets/css/base.css";
import axios from "axios";
import api from "@/url/api.js";
import "./assets/iconfont/iconfont.css";
import "babel-polyfill";
import cookies from "vue-cookies";
import Viewer from "v-viewer";
import VueVideoPlayer from "vue-video-player";
// import 'viewerjs/dist/viewer.css'
import VueI18n from "vue-i18n";

import App from "./App";
import router from "./router";
import "@/url/drag.js";
// 分页组件
import Pagination from "@/components/Pagination";
import plugins from "./plugins"; // plugins
axios.defaults.withCredentials = true;
Vue.prototype.$cookies = cookies;
Vue.use(uploader);
Vue.use(ElementUI);
Vue.use(myAxios);
Vue.use(Viewer);
Vue.use(VueVideoPlayer);
Vue.component("Pagination", Pagination);
require("video.js/dist/video-js.css");
require("vue-video-player/src/custom-theme.css");
// Vue.use(Viewer, {
//     defaultOptions: {
//     title: false,
//     }
// })
Vue.use(plugins);
Vue.use(VueI18n);

Vue.config.productionTip = false;
Vue.prototype.$echarts = echarts;
let curpath = null;
let no_need_login = [
  "/MimCaseTwo",
  "/share/document",
  "/share/gis",
  "/previewFileFormat",
  "/register_rotocol",
  "/demo1",
  "/demo2",
  "/demo3",
  "/view",
  "/drawingModelShare",
  "/MimCaseOne",
  "/MimCaseFour",
  "/MimCaseSix",
  "/RH_gis",
  "/RH_gis_other",
  "/YQS_geo_resource",
  "/YQS_trans_system",
  "/RoamingCase",
  "/ModelExplosion",
  "/Schedule",
  "/integrationModelPreview",
  "/unity",
];
// 是否正在刷新的标记
let isRefreshing = true;
// 重试队列，每一项将是一个待执行的函数形式
let subscribers = [];
const environmentType = api.environmentType;
console.log("environmentType mim", environmentType);
// 重新请求
function tautology(response) {
  const config = response.config;
  const token = response.data.msg.renew.token;
  config.headers["token"] = token;
  // console.log('重新请求token', token)
  let back = new Promise(function (resolve) {
    console.log("接口" + config.url + "请求失败，重新请求");
    resolve();
  });
  return back.then(function () {
    return axios(config);
  });
}
// 保存函数
function addSubscriber(callback) {
  subscribers.push(callback);
}
// promise 函数执行
function onAccessTokenFetched(token) {
  subscribers.forEach((cb) => cb(token));
  subscribers = [];
}
// 刷新token的请求函数
function refreshTokenRequst() {
  // const url = api.getAuthToken.url
  // const url = "http://mimco.miningcloud.com.cn:8041/api/v1" + "/user/authToken/";
  let url = "http://mim.miningcloud.com.cn:8041/user" + "/user/authToken/";
  if (api.environmentType == 1) {
    url = "http://10.30.0.201:8041/user" + "/user/authToken/";
  }
  axios.get(url).then((resp) => {
    if (resp && resp.data.code == 1) {
      if (resp.data.info && resp.data.info.renew && resp.data.info.renew.re) {
        const token = resp.data.info.renew.token;
        if (environmentType == 1) {
          $cookies.set("token", token, {
            expires: 7,
            path: "/",
          });
        } else {
          $cookies.set("token", token, {
            expires: 7,
            path: "/",
            domain: ".miningcloud.com.cn",
          });
        }

        axios.defaults.headers["token"] = token;
        onAccessTokenFetched(token);
        isRefreshing = true;
      }
    }
  });
}

axios.interceptors.response.use(
  (response) => {
    // refreshTokenRequst();
    if (response) {
      if (response.data.code == -1) {
        if (no_need_login.indexOf(curpath) != -1) {
          return response;
        }
        // console.log('response',response)
        cookies.remove("user_token");
        cookies.remove("child_sys_userInfo");
        cookies.remove("complete_user_info");
        cookies.remove("user_token", null, "miningcloud.com.cn");
        // 2022-5-13新增, 增加跳转到 登录中心
        $cookies.remove("role");
        $cookies.remove("token");
        $cookies.remove("tokenCode");
        $cookies.remove("username");
        if (environmentType == 1) {
          $cookies.set("fromPath", window.location.href, {
            expires: 7,
            path: "/",
          });
        } else {
          $cookies.set("fromPath", window.location.href, {
            expires: 7,
            path: "/",
            domain: ".miningcloud.com.cn",
          });
        }
        // window.location = 'http://10.30.0.201:8032'
        // window.location = 'http://mimco.miningcloud.com.cn:8032/';
        router.push("/sigin");
      } else if (response.data.code == -2) {
        const config = response.config;
        if (isRefreshing) {
          refreshTokenRequst();
        }
        isRefreshing = false;
        const retryOriginalRequest = new Promise((resolve) => {
          addSubscriber(() => {
            resolve(axios(config));
          });
        });
        return retryOriginalRequest;
      } else {
        return response;
      }
      return response;
    }
  },
  (error) => {
    console.log("err" + error); // for debug
    return Promise.reject(error);
  }
);

axios.interceptors.request.use(
  function (config) {
    config.headers["tokenCode"] =
      config.headers["tokenCode"] || $cookies.get("tokenCode");
    config.headers["token"] = config.headers["token"] || $cookies.get("token");
    config.headers["pid"] =
      config.headers["pid"] || sessionStorage.getItem("pid");
    return config;
  },
  function () {
    return Promise.reject(error);
  }
);

router.beforeEach((to, from, next) => {
  let token = $cookies.get("token");
  let tokenCode = $cookies.get("tokenCode");
  const path = to.path;
  curpath = to.path;

  if (path == "/guidePage") {
    if (to.meta.title) {
      document.title = "MIM协同交付平台";
    }
    next();
  } else if (path === "/sigin") {
    if (to.meta.title) {
      document.title =
        "MIM协同交付平台—以项目为核心的数字化交付及全流程协同工作";
    }
    next();
  } else if (path === "/otherLogin") {
    //其他系统跳转登录
    next();
  } else {
    if (token && tokenCode) {
      next();
    } else {
      if (environmentType == 1) {
        $cookies.set("fromPath", window.location.href, {
          expires: 7,
          path: "/",
        });
      } else {
        $cookies.set("fromPath", window.location.href, {
          expires: 7,
          path: "/",
          domain: ".miningcloud.com.cn",
        });
      }
      if (no_need_login.indexOf(path) != -1) {
        next();
      } else {
        // window.open(api.base_user_center, "_self");
        next("/sigin");
      }
    }
    // if (cookies.get("user_token") === null) {
    //   cookies.set("user_from", {
    //     from: 'http://mimco.miningcloud.com.cn:8032/'
    //   }, 60 * 60 * 24 * 7, null, "miningcloud.com.cn")
    //   // window.location = 'http://mimco.miningcloud.com.cn:8031/'
    //   let no_need_login = ['/MimCaseTwo', '/share/document', '/previewFileFormat', '/register_rotocol', '/demo1', '/demo2', '/demo3', '/view', '/drawingModelShare', '/MimCaseOne', '/MimCaseFour', '/MimCaseSix', '/RH_gis', '/YQS_geo_resource', '/YQS_trans_system', '/RoamingCase', '/ModelExplosion'];
    //   if (no_need_login.indexOf(path) != -1) {
    //     next()
    //   } else {
    //     next('/sigin')
    //   }
    // } else {
    //   next()
    // }

    if (path === "/demo1") {
      window.location =
        "http://mimco.miningcloud.com.cn:8032/#/previewFileFormat?fileId=2252371365188896&file_name=MIM.CoPlat";
    }
    if (path === "/demo2") {
      window.location =
        " http://mimco.miningcloud.com.cn:8032/#/previewFileFormat?fileId=2252372555937056&file_name=MIM.CoPlat";
    }
    if (path === "/demo3") {
      window.location = "http://mimco.miningcloud.com.cn:8032/#/view";
    }
  }
});

const i18n = new VueI18n({
  locale: "zh", // 语言标识
  messages: {
    zh: require("./assets/lang/zh"),
    en: require("./assets/lang/en"),
  },
});
var mixin = {
  methods: {
    addClass(flag) {
      this.active = flag;
      if (flag == 2) {
        this.$i18n.locale = "en";
      } else {
        this.$i18n.locale = "zh";
      }
    },
    // 自定义工具栏
    resetTool() {
      //自己定义一个数组，配置自己想要的button
      this.WebAppConfig.Buttons = [
        "Home",
        "RectangleSelect",
        "Measure",
        "Section",
        "Walk",
        "Setting",
        "Property",
        "FullScreen",
      ];
    },
    // 重写工具条基本信息
    updateToolMsg(app) {
      //获取工具条对象
      var toolbar = app.getToolbar("MainToolbar");
      var btnConfig = new Glodon.Bimface.UI.Button.ButtonConfig();
      var btn = new Glodon.Bimface.UI.Button.Button(btnConfig);
      //设置新增按钮的样式
      btn.setHtml(
        `<i class="el-icon-warning-outline" style="font-size: 27px"></i>`
      );
      //设置按钮的点击事件
      btn.addEventListener("Click", () => {
        let objectdata = {
          worldPosition: {
            x: 7.318850079011344,
            y: -2.4397735415188277,
            z: 5.226456806162779,
          },
        };
        if (!this.displayrectangle) {
          this.addToolItem(objectdata);
        } else {
          this.closeRectangle();
        }
        this.displayrectangle = !this.displayrectangle;
      });
      //设置按钮的位置
      toolbar.insertControl(6, btn);
    },
    // 添加标签
    addToolItem(objectdata) {
      //获取明细表list
      let viewerMsg = this.viewer
        ? this.viewer.getInformation()
        : this.viewer3D
        ? this.viewer3D.getInformation()
        : this.viewer2D.getInformation();
      var config = new Glodon.Bimface.Plugins.Drawable.CustomItemConfig();
      var rectangle = document.createElement("div");
      rectangle.innerHTML = `<div class="bf-panel bf-basicInfo-panel bf-has-title bf-pinned" style="left: 50%; top: 50%; width: 300px; height: 210px; transform: translate(-50%, -50%);">
      <div class="bf-close" id="bf-close"></div>
      <div class="bf-title" style="cursor: move; user-select: none;">基本信息</div>
      <div class="bf-panel-body">
      <div class="bf-panel-header"></div>
      <div class="bf-panel-container bf-scroll-bar">
         <div class="bf-info">
         <ul class="bf-info-list">
         <li>构件数量：<span class="bf-info-value">${viewerMsg.elements}</span></li>
         <li>三角面数量：<span class="bf-info-value">${viewerMsg.triangles}</span></li>
         <li>顶点数量：<span class="bf-info-value">${viewerMsg.vertices}</span></li>
        </ul></div>
      </div>
      </div>
      </div>`;
      config.content = rectangle;
      //设置可以拖拽
      config.draggable = true;
      config.offsetY = -32;
      config.viewer = this.viewer;
      //生成customItem实例
      var customItem = new Glodon.Bimface.Plugins.Drawable.CustomItem(config);
      // 添加自定义标签
      this.drawableContainer.addItem(customItem);
      document.getElementById("bf-close").addEventListener("click", () => {
        this.closeRectangle();
        this.displayrectangle = !this.displayrectangle;
      });
    },
    // 关闭标签
    closeRectangle() {
      this.drawableContainer.clear();
    },
  },
};
//注册全局防止连续点击指令
Vue.directive("ld-click", {
  inserted(el, binding) {
    el.addEventListener("click", () => {
      el.style.pointerEvents = "none";
      const delay = binding.value || 1000;
      setTimeout(() => {
        el.style.pointerEvents = "auto";
      }, delay);
    });
  },
});

//全局注入mixin
Vue.mixin(mixin);
/* eslint-disable no-new */

var vue = new Vue({
  el: "#app",
  i18n,
  router,
  components: {
    App,
  },
  template: "<App/>",
  render: (h) => h(App),
}).$mount("#app");
export default vue;



// WEBPACK FOOTER //
// ./src/main.js